import { UseFormReturn } from 'react-hook-form';
import { AdvancedConceptionData } from '../AdvancedConception/AdvancedConception';
import { QuickSimulationData } from '../QuickSimulation/QuickSimulation';
import { MaterialsToComplete } from '../ProjectSimulator';

type ProjectSimulatorNavigationType = {
  title: string;
  translationKey: string;
  tab: PROJECT_SIMULATOR_TABS;
};

export type Unit = 'm²' | 'total';

export type ListValueProps = {
  id: number;
  phraseKey: string;
  defaultValue: string;
};

export type FormValues = {
  quickSimulation: QuickSimulationData;
  advancedConception: AdvancedConceptionData;
  refUnit: Unit;
  ddv: number;
};

export type NavigationTabsProps = {
  currentTab: PROJECT_SIMULATOR_TABS;
  handleNavigation: (tab: PROJECT_SIMULATOR_TABS) => void;
  form: UseFormReturn;
  formValues: FormValues;
  shouldPatchForm: boolean;
  visitedTabs?: PROJECT_SIMULATOR_TABS[];
  areAllMaterialsCompleted: boolean;
};

export enum PROJECT_SIMULATOR_TABS {
  QUICK_SIMULATION = 1,
  ADVANCED_CONCEPTION = 2,
  SUMMARY = 3,
}

export const allTabsVisited = [
  PROJECT_SIMULATOR_TABS.QUICK_SIMULATION,
  PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION,
  PROJECT_SIMULATOR_TABS.SUMMARY,
];

export const projectSimulatorNavigations: ProjectSimulatorNavigationType[] = [
  {
    title: 'Simulation rapide',
    translationKey: 'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.TAB',
    tab: PROJECT_SIMULATOR_TABS.QUICK_SIMULATION,
  },
  {
    title: 'Conception avancée (facultatif)',
    translationKey: 'APP.PROJECT.SIMULATOR.ADVANCED_CONCEPTION.TAB',
    tab: PROJECT_SIMULATOR_TABS.ADVANCED_CONCEPTION,
  },
  {
    title: 'Synthèse',
    translationKey: 'APP.PROJECT.SIMULATOR.SUMMARY.TAB',
    tab: PROJECT_SIMULATOR_TABS.SUMMARY,
  },
];

export const PROJECT_SIMULATOR_TOTAL_TABS = projectSimulatorNavigations.length;

export const selectStyle = {
  '.MuiOutlinedInput-notchedOutline': {
    borderStyle: 'none',
  },
  '.MuiOutlinedInput-input': {
    border: '1px solid #789ADE',
    padding: '10px',
    fontSize: '10px',
    borderRadius: '9px',
    color: '#789ADE',
  },
};

export const formatValueToNumber = (value) => {
  if (typeof value === 'string' && value.includes(',')) {
    return value.replace(',', '.');
  }
  return value;
};


export type ValidationRule = {
  validate: (value) => boolean;
};

type ProjectSimulatorFieldRules = {
  default: ValidationRule;
  positiveNumber: ValidationRule;
  percentage: ValidationRule;
  ratioNumber: ValidationRule;
  lifeSpan: ValidationRule;
};

export const projectSimulatorFieldRules: ProjectSimulatorFieldRules = {
  default: {
    validate: (value) => value !== '',
  },
  positiveNumber: {
    validate: (value) => Number(value) > 0,
  },

  percentage: {
    validate: (value) => value !== '' && Number(value) >= 0 && Number(value) <= 100,
  },

  ratioNumber: {
    validate: (value) => value !== '' && value >= 0 && value <= 1,
  },

  lifeSpan: {
    validate: (value) => Number(value) > 0 && Number(value) <= 50,
  },
};

export const getAllMaterialsSums = (listMaterials: Array<MaterialsToComplete[]>) =>
  listMaterials.map((materialsSum) =>
    materialsSum.reduce((acc, curr) => acc + curr.percent, 0)
  );

export const areAllMaterialsCompleted = (listMaterialsSums: number[]) =>
  listMaterialsSums.every((materialSynthese) => materialSynthese === 100);
